<template>
  <footer class="demo_wrap2" :class="lista_evento.fly1 ? 'demo_wrap_computer' : 'demo_wrap_computer2'">
    <!-- <img class="ba" src="show.webp" alt="" /> -->
    <div class="footer-top">
      <div class="row align-items-center justify-content-md-between pt-1">
        <div class="col-md-6 col-12">
          <h5 class="text-white font-weight mb-2" style="font-size:14px;">
            Viva Ticket LTDA - CNPJ 19.770.969/0001-70
          </h5>
        </div>
        <div class="col-md-6 col-12 text-lg-center btn-wrapper">
        </div>
      </div>
    </div>

    <div style="font-size:14px" :style="lista_evento.fly1 ? 'margin-bottom:30px;' : ''"
      class="row align-items-center justify-content-md-between ">
      <div class="col-md-8 col-8 t">
        <div class="copyright">
          Copyright &copy; {{ year }}
          <i class="font-weight-900"> Viva Ticket.</i> Todos os Direitos
          Reservados.
        </div>
      </div>
      <div class="col-md-4 col-4 t">
        Desenvolvido por <i class="text-success"> Aut Steel tech </i>
        <!-- | -->
        <!-- Codificado por <i class="text-success">Stanier</i> -->
      </div>
    </div>
  </footer>
  <!-- End Footer -->

  <!-- End Footer -->
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    lista_evento() {
      return this.$store.state.evento.evento;
    },
    check_mobile() {
      var check = false; //wrapper no check
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
  }
};
</script>
<style>
/* .imgback {
    content: "";
  
    opacity: 0.7;
    background-size: cover;
  
    background-color: #cccccc;
    background-repeat: no-repeat;
  
  } */
@media (min-width: 700px) {

  .demo_wrap_computer {
    height: 120px;
  }

  .demo_wrap_computer1 {
    height: 70px;
  }

  .demo_wrap2 {
    background: #000000;
    overflow: hidden;
    width: 100%;
    background-image: url("https://https://vivaticket.autsteeltech.com/#/show.webp");
    background-repeat: no-repeat;
    background-position: 50% 0;
    background-size: cover;
    /* z-index: 1; */
    /* padding: 19px; */
    position: fixed;
    z-index: 1;
    bottom: 0px;
    color: azure;
  }

  /* You could use :after - it doesn't really matter */

}

@media (max-width: 660px) {
  .demo_wrap2 {
    background: #000000;
    overflow: hidden;
    /* background-image: url("https://vivaticket.autsteeltech.com/wp-content/themes/boraticket/assets/img/xfooter-bg.webp.pagespeed.ic.bRCEzz3dJO.webp"); */
    background-image: url("https://vivaticket.autsteeltech.com/show.webp");
    width: 100%;
    background-repeat: no-repeat;
    background-position: 50% 0;
    background-size: cover;
    opacity: 0.96;
  }
  .t {
    font-size: 12px;
  }

  .demo_wrap {
    background: #000000;
    overflow: hidden;
    /* background-image: url("https://vivaticket.autsteeltech.com/wp-content/themes/boraticket/assets/img/xfooter-bg.webp.pagespeed.ic.bRCEzz3dJO.webp"); */
    width: 100%;
    height: 160px;
    padding: 10px;
    position: fixed;
    z-index: 1;
    bottom: 0px;
    color: azure;
  }

  .demo_wrap2 {
    padding: 3px 10px 30px 10px;
    position: fixed;
    bottom: 0px;
    color: azure;
  }
}
</style>